import React from "react";
import { getHorizontalAlign } from "helpers/get-section-align";
import getTitleColor from "helpers/get-title-color";

const EventsAndBenefitsSubheading = ({ data }) => {
  const {
    horizontalAlign: { horizontalAlign },
    backgroundColor,
    title,
    description,
    titleColor
  } = data;

  return (
    <div style={{ backgroundColor: backgroundColor?.hex }} className={`py-[120px] sm:py-16 flex relative ${getHorizontalAlign(horizontalAlign)}`}>
      <div className="container relative z-[4] flex justify-center items-center flex-col">
        <h2 className={`font-display leading-[78px] sm:leading-8 font-bold !text-yellow-400 ${getTitleColor(titleColor)} text-center text-[58px] sm:text-[32px]`}>{title}</h2>
        <p className="text-gray-700 font-montserrat mt-2.5 text-lg sm:text-base text-center font-medium max-w-[610px]"> {description} </p>
      </div>
    </div>
  );
};

export default EventsAndBenefitsSubheading;
